"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceStatus = exports.GatewayStatus = exports.MessageAction = void 0;
var MessageAction;
(function (MessageAction) {
    MessageAction["ACK"] = "ACK";
    MessageAction["DOWNLINK"] = "DOWNLINK";
    MessageAction["QUEUED"] = "QUEUED";
    MessageAction["SENT"] = "SENT";
    MessageAction["ERROR"] = "ERROR";
    MessageAction["JOIN"] = "JOIN";
    MessageAction["STATUS"] = "STATUS";
    MessageAction["TXACK"] = "TXACK";
    MessageAction["UPLINK"] = "UPLINK";
    MessageAction["WTF"] = "WTF";
})(MessageAction || (exports.MessageAction = MessageAction = {}));
var GatewayStatus;
(function (GatewayStatus) {
    GatewayStatus["COMMISSIONED"] = "C";
    GatewayStatus["DECOMMISSIONED"] = "D";
    GatewayStatus["NOT_COMMISSIONED"] = "N";
})(GatewayStatus || (exports.GatewayStatus = GatewayStatus = {}));
var DeviceStatus;
(function (DeviceStatus) {
    DeviceStatus["COMMISSIONED"] = "C";
    DeviceStatus["DECOMMISSIONED"] = "D";
    DeviceStatus["NOT_COMMISSIONED"] = "N";
})(DeviceStatus || (exports.DeviceStatus = DeviceStatus = {}));
